var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKonvasIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.6595 5.34837C0 6.94054 0 8.95898 0 12.9958V27.0041C0 31.041 0 33.0595 0.6595 34.6516C1.53883 36.7745 3.22547 38.4612 5.34837 39.3405C6.94054 40 8.95898 40 12.9958 40H27.0041C31.041 40 33.0595 40 34.6516 39.3405C36.7745 38.4612 38.4612 36.7745 39.3405 34.6516C40 33.0595 40 31.041 40 27.0042V12.9959C40 8.95898 40 6.94054 39.3405 5.34837C38.4612 3.22547 36.7745 1.53883 34.6516 0.6595C33.0595 0 31.041 0 27.0042 0H12.9959C8.95898 0 6.94054 0 5.34837 0.6595C3.22547 1.53883 1.53883 3.22547 0.6595 5.34837ZM23.0862 10.8882C23.1234 10.7534 22.9664 10.6497 22.857 10.7369L11.6064 19.7009C11.5141 19.7745 11.5442 19.9217 11.658 19.9531L17.6719 21.6125C17.7488 21.6338 17.7939 21.7133 17.7727 21.7901L15.8604 28.7205C15.8232 28.8553 15.9802 28.959 16.0895 28.8718L27.3402 19.9077C27.4325 19.8342 27.4024 19.687 27.2886 19.6556L21.2747 17.9961C21.1978 17.9749 21.1527 17.8954 21.1739 17.8185L23.0862 10.8882Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKonvasIcon);
export default __webpack_public_path__ + "static/media/konvas-icon.a6fad0297de90ebe587aaf3b32f1ff55.svg";
export { ForwardRef as ReactComponent };